import { Component, OnInit } from '@angular/core';
import { LogSistemaService } from './log-sistema.service';
import { DATOS_API } from 'app/auth/auth.datos';


///IDIOMAS
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-log-sistema',
  templateUrl: './log-sistema.component.html',
  styleUrls: ['./log-sistema.component.scss']
})
export class LogSistemaComponent implements OnInit {
  cargando = true;
  logs:any;
  pagina: number = 1;
  search: string = '';
  totalRegistros: number;
  siguiente: boolean;
  anterior: boolean;
  nextPage: number;
  prevPage: number;
  displayedColumns: string[] = ['imagen', 'ipcliente', 'usuario', 'empresa','plataforma', 'estatus', 'resultado', 'fecha'];
  urlApi:any;
  logo:any;
  validarPagina:boolean=true;

  constructor(
    private logService: LogSistemaService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService
  ) {
    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.cargarLogs(this.pagina);
  }

  cargarLogs(pagina:number){
    this.cargando = true;
    this.urlApi=DATOS_API.url.substring(0,(DATOS_API.url.length-5));
    this.logo=this.urlApi+'/surveyadministrator/backend/';
    this.pagina=pagina;
    this.logService.logsSistema(this.pagina, this.search).subscribe( (resp: any) => {
      console.log(resp);
      this.logs = resp.resultado.docs;
      this.totalRegistros = resp.resultado.totalDocs;
      this.anterior = resp.resultado.hasPrevPage;
      this.siguiente = resp.resultado.hasNextPage;
      this.nextPage = resp.resultado.nextPage;
      this.prevPage = resp.resultado.prevPage;
      this.cargando = false;
    });
  }

}
